import React from "react";
import { Row, Col, Button } from "react-bootstrap";

const SaveButton = ({ save, isSaving }) => (
  <Row>
    <Col>
      <Button variant="primary" block onClick={save} disabled={isSaving}>
        SAVE
      </Button>
    </Col>
  </Row>
);

export default SaveButton;
